import { checkSelected } from './parseFiltersFromQuery';
import { parseQuery } from './queryParams';

export const getBrandsFromPromotions = (promotions) => {
    const brands = [];

    if (!promotions) {
        return brands;
    }

    // eslint-disable-next-line
    for (let promotion of promotions) {
        if (brands.length === 10) {
            break;
        }

        if (brands.some((brand) => brand.account === promotion.account)) {
            // eslint-disable-next-line no-continue
            continue;
        }

        brands.push({
            name: promotion.brandName,
            key: promotion.account,
            account: promotion.account
        });
    }

    return checkSelected(brands, parseQuery().brands);
};
